/* eslint-disable no-case-declarations */
import * as actionType from 'src/store/actions/fileExplorer.action';
import { FileExplorerState } from '../initial.state';

const fileExplorerReducer = (state = new FileExplorerState(), action) => {
  switch (action.type) {
    case actionType.ADD_FILE:
      const nonCancelledFiles = [...action.data].filter(file => file.fileName !== null);
      return { ...state, files: [...state.files, ...nonCancelledFiles] };

    case actionType.GET_ALL_LIVE_CLASS_RECORDINGS:
      return {
        ...state,
        liveClassRecordings: action.data.fileList,
        currentState: { ...state.currentState, unitId: action.data.catalogueId },
      };

    case actionType.UPDATE_PROGRESS:
      const newArr = [...state.files];
      const fileIndex = newArr.findIndex(file => file.uuid === action.data.uuid);
      newArr[fileIndex] = {
        ...newArr[fileIndex],
        progressNum: action.data.progressUpdate,
      };
      return {
        ...state,
        files: newArr,
      };

    case actionType.UPDATE_INQUEUE_STATUS:
      const newArrInQueue = [...state.files];
      const fileIndexInQueue = newArrInQueue.findIndex(file => file.id === action.data.file.id);
      newArrInQueue[fileIndexInQueue] = {
        ...newArrInQueue[fileIndexInQueue],
        inQueue: action.data.flag,
      };
      return {
        ...state,
        files: newArrInQueue,
      };

    case actionType.UPDATE_UPLOADEDTODB_STATUS:
      const newArrUploadDb = [...state.files];
      const fileIndexUploadDb = newArrUploadDb.findIndex(file => file.uuid === action.data.uuid);
      newArrUploadDb[fileIndexUploadDb] = {
        ...newArrUploadDb[fileIndexUploadDb],
        uploadedToDb: action.data.uploadedToDbStatus,
      };
      return {
        ...state,
        files: newArrUploadDb,
      };

    case actionType.UPDATE_UPLOADEDTOS3_STATUS:
      const newArrUploads3 = [...state.files];
      const fileIndexUploads3 = newArrUploads3.findIndex(file => file.uuid === action.data.uuid);
      newArrUploads3[fileIndexUploads3] = {
        ...newArrUploads3[fileIndexUploads3],
        uploadedToS3: action.data.uploadedToS3Status,
      };
      return {
        ...state,
        files: newArrUploads3,
      };

    case actionType.UPDATE_UPLOAD_CANCELLED_STATUS:
      const newArrUpdateCancel = [...state.files];
      const fileIndexUpdateCancel = newArrUpdateCancel.findIndex(
        file => file.id === action.data.id
      );

      if (action.data.newUuid) {
        newArrUpdateCancel[fileIndexUpdateCancel] = {
          ...newArrUpdateCancel[fileIndexUpdateCancel],
          cancelled: action.data.cancelledStatus,
          uuid: action.data.newUuid,
          progressNum: 0,
        };
      } else {
        newArrUpdateCancel[fileIndexUpdateCancel] = {
          ...newArrUpdateCancel[fileIndexUpdateCancel],
          cancelled: action.data.cancelledStatus,
          progressNum: 0,
        };
      }

      return {
        ...state,
        files: newArrUpdateCancel,
      };

    case actionType.ON_CLEAR:
      const newArrClear = [...state.files].filter(item => item.uuid !== action.data);
      // console.log(action.data, newArrClear);
      return {
        ...state,
        files: newArrClear,
      };

    case actionType.ALL_CLEAR:
      return {
        ...state,
        files: [],
      };

    case actionType.CLEAR_UPLOADED:
      const clearUploadTemp = [...state.files].filter(item => item.uploadedToDb !== true);

      return {
        ...state,
        files: clearUploadTemp,
      };

    case actionType.UPDATE_CURRENT_STATE:
      return {
        ...state,
        currentState: action.data,
        currentStateCache: action.data, // [Hotfix: SP]
      };

    case actionType.RESET_FILEEXPLORER_STORE:
      return {
        ...state,
        currentState: {
          isSubjectsFolder: true,
          viewType: 'Subjects',
          subject: '',
          subjectId: '',
          unit: '',
          unitId: '',
          topic: '',
          topicId: '',
        },
        files: [],
        rawEachSubject: {},
        currentList: [],
      };

    case actionType.RESET_CURRENT_STATE:
      return {
        ...state,
        currentState: {
          isSubjectsFolder: true,
          viewType: 'Subjects',
          subject: '',
          subjectId: '',
          unit: '',
          unitId: '',
          topic: '',
          topicId: '',
        },
        rawEachSubject: {},
        currentList: [],
      };

    case actionType.UPDATE_CURRENT_SUBJECT:
      return {
        ...state,
        rawEachSubject: action.data,
      };

    case actionType.UPDATE_CURRENT_LIST:
      return {
        ...state,
        currentList: action.data,
      };

    case actionType.APPEND_CURRENT_LIST:
      // console.log(state.rawEachSubject);
      return {
        ...state,
        currentList: [...state.currentList, action.data],
      };

    case actionType.GET_ALL_SUBJECTS:
      const subjectsList = action.data;
      const modifiedSubjectsList = subjectsList.map(subject => ({
        Name: subject.subjectName,
        Id: subject.subjectId,
        Length: subject.noOfUnits,
      }));

      if (state.currentState.viewType !== 'Files') {
        return {
          ...state,
          allSubjects: modifiedSubjectsList,
          currentList: modifiedSubjectsList,
        };
      }
      break;
    case actionType.GET_SUBJECT_BY_ID:
      return {
        ...state,
        currentList: modifiedSubjectsList,
      };

    default:
      return state;
  }
};

export { fileExplorerReducer };
